import { Link, useParams } from "react-router-dom";
import { useNotices } from "../hooks/useClubInfo";
import { MarkerBadge, severityTone } from "../components/MarkerBadge";

export function NewsDetail() {
  const { clubId, noticeId } = useParams();
  const { notices, loading } = useNotices(clubId);
  const notice = notices.find((n) => n.id === noticeId);

  return (
    <main className="mx-auto min-h-dvh max-w-md px-5 pb-24 pt-6">
      <Link to={`/club/${clubId}/info?tab=news`} className="inline-flex items-center gap-1 text-sm font-medium text-turf-700">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
          <path d="m15 6-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Zurück zu News
      </Link>

      {loading && (
        <div className="mt-6 animate-fade-up space-y-3">
          <div className="skeleton h-6 w-24 rounded-full" />
          <div className="skeleton h-8 w-3/4 rounded" />
          <div className="skeleton h-4 w-full rounded" />
          <div className="skeleton h-4 w-5/6 rounded" />
        </div>
      )}
      {!loading && !notice && <p className="mt-6 text-ink-400">Mitteilung nicht gefunden.</p>}

      {notice && (
        <article className="card animate-fade-up mt-5 rounded-2xl p-5">
          <div className="flex items-center gap-2">
            <MarkerBadge tone={severityTone(notice.severity)}>{notice.severity}</MarkerBadge>
            <span className="text-sm text-ink-400">
              {new Date(notice.createdAt).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" })}
            </span>
          </div>
          <h1 className="mt-3 font-display text-2xl font-semibold text-turf-900">{notice.title}</h1>
          <div className="mt-2 rule-scorecard" />
          <p className="mt-4 whitespace-pre-line text-base leading-relaxed text-ink-900">{notice.text}</p>
        </article>
      )}
    </main>
  );
}
